import { faEdit, faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from 'components/base/Button';
import CompanyProfileCard from 'components/cards/CompanyProfileCard';
// import DealsPrintingDimensionsCard from 'components/cards/DealsPrintingDimensionsCard';
// import DealsOtherInformation from 'components/forms/DealsOtherInformation';
import DealDetailsInfo from 'components/modules/crm/deals/DealDetailsInfo';
// import DealDetailsTab from 'components/modules/crm/deals/DealDetailsTab';
import { SITE_ENDPOINT } from 'Constant';
import { DealDetailsInfoType } from 'data/crm/dealDetailsInfo';
import { JobClient } from 'data/users';
import { Placeholder } from 'react-bootstrap';
import { Col, Row } from 'react-bootstrap';
import { useQuery, useQueryClient } from 'react-query';
import { useParams, Link, useNavigate } from 'react-router-dom';
import { DELETE_CUSTOMER, GET_CUSTOMER } from 'services/api/customer';

const ViewCustomerDetail = () => {
  const { id } = useParams<{ id?: string }>();
  const { isLoading, data: company } = useQuery(['getCustomer', id], () =>
    id ? GET_CUSTOMER(id) : Promise.reject('No id provided')
  );
  const navigate = useNavigate();
  const queries = useQueryClient();

  function transformJobClientToDetailsInfo(
    jobClient: JobClient
  ): DealDetailsInfoType[][] {
    return [
      [
        {
          id: 1,
          title: 'Country',
          value: jobClient?.country,
          icon: 'map',
          color: 'success'
        },
        {
          id: 2,
          title: 'Address',
          value: jobClient?.address,
          icon: 'map-pin',
          color: 'info'
        }
      ],
      [
        {
          id: 3,
          title: 'Phone',
          value: jobClient?.phoneNumber,
          icon: 'phone',
          color: 'primary'
        },
        {
          id: 4,
          title: 'Email',
          value: jobClient?.customerRepresentative?.email,
          icon: 'mail',
          color: 'warning'
        }
      ],
      [
        {
          id: 5,
          title: 'Contact Name',
          value: `${jobClient?.customerRepresentative?.firstName} ${jobClient?.customerRepresentative?.lastName}`,
          icon: 'users',
          color: 'success'
        },
        {
          id: 6,
          title: 'Created By',
          value: 'N/A', // Assuming JobClient doesn't have this field
          icon: 'edit',
          color: 'info'
        }
      ],
      [
        {
          id: 7,
          title: 'Create Date',
          value: jobClient?.createdAt
            ? new Date(jobClient?.createdAt).toLocaleDateString('en-US', {
                month: 'short',
                day: 'numeric',
                year: 'numeric'
              })
            : 'N/A',
          icon: 'clock',
          color: 'info'
        },
        {
          id: 8,
          title: 'Closing Date',
          value: 'N/A', // Assuming JobClient doesn't have this field
          icon: 'edit',
          color: 'warning'
        }
      ]
    ];
  }
  const transformedData = transformJobClientToDetailsInfo(
    company?.data as JobClient
  );

  const handleDelete = async () => {
    try {
      await DELETE_CUSTOMER(String(id));
      queries.invalidateQueries('getAllCustomers');
      queries.invalidateQueries('get_customer');
      queries.invalidateQueries('getCustomers');
      navigate(`/home/apps/${SITE_ENDPOINT.COMPANY.INDEX}`);
    } catch (error) {
      console.error('Error deleting customer:', error);
    }
  };
  return (
    <div>
      <div className="mb-9">
        <Row className="align-items-center justify-content-between g-3 mb-4">
          <Col md="auto">
            <h2 className="mb-0">Company details</h2>
          </Col>
          <Col md="auto" className="d-flex">
            <Link
              to={`${SITE_ENDPOINT.BASE}${SITE_ENDPOINT.COMPANY.EDIT_COMPANY}/${
                (company?.data as any)?.id || company?.data._id
              }`}
            >
              <Button variant="phoenix-secondary" className="px-3 px-sm-5 me-2">
                <FontAwesomeIcon icon={faEdit} className="me-sm-2" />
                <span className="d-none d-sm-inline">Edit</span>
              </Button>
            </Link>
            <Button
              variant="phoenix-danger"
              className="me-2"
              startIcon={<FontAwesomeIcon icon={faTrash} className="me-2" />}
              onClick={() => {
                confirm('You sure you want to delete this company') &&
                  handleDelete();
              }}
            >
              <span>Delete Company</span>
            </Button>
            {/* <Dropdown>
              <Dropdown.Toggle
                variant="phoenix-secondary"
                className="px-3 dropdown-caret-none"
              >
                <FontAwesomeIcon icon={faEllipsis} />
              </Dropdown.Toggle>

              <Dropdown.Menu className="py-2" style={{ zIndex: 9999 }}>
                <Dropdown.Item href="#!">View profile</Dropdown.Item>
                <Dropdown.Item href="#!">Report</Dropdown.Item>
                <Dropdown.Item href="#!">Manage notifications</Dropdown.Item>
                <Dropdown.Item href="#!" className="text-danger">
                  Delete Lead
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown> */}
          </Col>
        </Row>
        <Row className="g-4 g-xl-6">
          <Col xl={5} xxl={4}>
            <div className="sticky-leads-sidebar">
              {isLoading ? (
                <div className="g-3 mt-8 mb-8">
                  <Placeholder as="p" animation="glow">
                    <Placeholder xs={12} />
                  </Placeholder>
                  <Placeholder as="p" animation="glow">
                    <Placeholder xs={12} />
                  </Placeholder>
                </div>
              ) : (
                <>
                  <CompanyProfileCard
                    company={company?.data as JobClient}
                    className="mb-3"
                  />
                  {/* <DealsOtherInformation /> */}
                </>
              )}
            </div>
          </Col>
          <Col xl={7} xxl={8}>
            {/**
             * @TODO : Add Company Deals Card
             * @TODO : Add Company Details Activities
             *
             */}
            {/* <DealsPrintingDimensionsCard stats={stats} className="mb-5" /> */}
            <DealDetailsInfo data={transformedData} className="mb-7" />
            {/* <DealDetailsTab /> */}
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default ViewCustomerDetail;
